/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function ApiReorderClassificationItemsInputFromJSON(json) {
    return ApiReorderClassificationItemsInputFromJSONTyped(json, false);
}
export function ApiReorderClassificationItemsInputFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'classificationItemId': !exists(json, 'classificationItemId') ? undefined : json['classificationItemId'],
        'order': !exists(json, 'order') ? undefined : json['order'],
    };
}
export function ApiReorderClassificationItemsInputToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'classificationItemId': value.classificationItemId,
        'order': value.order,
    };
}
